// MF-554 — A Library item's sample rows shaped like a real data answer ({ rows, encoding, meta }), so
// the Board Builder can draw it instantly (Library preview, a new tile before its data arrives).
// meta.sample = true → the tile labels it "Sample data".
export const sampleData = (item) => {
  if (!item) return null
  const isChart = item.kind === 'chart'
  return {
    rows: item.sample || [],
    encoding: isChart
      ? { x: item.presentation?.x || null, series: item.presentation?.series || [] }
      : { fields: item.card?.fields || [] },
    meta: {
      code: item.code,
      kind: item.kind,
      title: item.title,
      description: item.description,
      presentation: isChart
        ? {
            types: item.presentation.types,
            defaultType: item.presentation.defaultType,
            x: item.presentation.x || null,
            yMax: item.presentation.yMax ?? null,
            toneKey: item.presentation.toneKey || null
          }
        : null,
      card: isChart
        ? null
        : { component: item.card.component, x: item.card.x || null, options: item.card.options || {} },
      empty: !(item.sample || []).length,
      emptyText: item.presentation?.emptyText || item.card?.emptyText,
      sample: true
    }
  }
}

/** Key a preview by item + its fixed params (the batch endpoint answers by this key). */
export const previewKey = (code, params = {}) => `${code}|${JSON.stringify(params || {})}`
